<template>
    <label class="form-control-label" v-if="(title ?? '').length > 0">{{title}}</label>
    <!--<select class="form-control d-none" v-model="value" :disabled="disabled">
        <option v-for="item in listApplyDates" :value="item" :key="item.id">{{getTitle(item)}}</option>
    </select>-->
    <div class="input-group">
        <select class="form-control" v-model="selectedYear" style="width:15%">
            <option value="0">--</option>
            <option v-for="item in yearList" :value="item.value" :key="item.value">{{item.title}}</option>
        </select>
        <select class="form-control" v-model="selectedMonth" style="width:20%">
            <option value="0">--</option>
            <option v-for="item in monthList" :value="item.value" :key="item.value">{{item.title}}</option>
        </select>
        <vue-select v-model="selectApplyDate" style="width:65%" :options="finalListApplyDates" :disabled="disabled"
                    dir="rtl" label="fullTitle" class="vue-select-incomponent-applydate">
            <template #no-options="{ search, searching, loading }">
                موردی یافت نشد!
            </template>
        </vue-select>
    </div>
</template>

<script>

    export default {
        name: "ApplyDateSelector",
        props: {
            value: {
                type: Object,
                default: {},
            },
            listData: {
                type: Array,
                default: []
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            title: {
                type: String,
                default: 'مشاهده تاریخچه اطلاعات ثبت شده',
            }
        },
        emits: ["fnCallback"],
        data() {
            return {
                deleteReason: '',
                selectApplyDate: {},
                listApplyDates: [],
                finalListApplyDates: [],
                yearList: this.$yearList(),
                monthList: this.$monthList,
                unWatchValue: null,
                countTrySetValue: 0,
                selectedYear: 0,
                selectedMonth: 0
            };
        },
        components: {
        },
        watch: {
            listData(newVal) {
                this.listApplyDates = this.finalListApplyDates = [];
                let vm = this;
                if (newVal && newVal.length > 0) {
                    for (var i = 0; i < newVal.length; i++) {
                        let item = newVal[i];
                        let monthName = this.$filters.shamsiToMonthYear(item.startDate);

                        item.monthNo = this.$filters.getMonthNo(item.startDate);
                        item.yearNo = this.$filters.getYearNo(item.startDate);

                        if (monthName.length > 0) {
                            item.title = monthName;
                        }
                        else {
                            item.title = vm.$filters.toggleDate(item.startDate) + (item.endDate && item.endDate > 0 ? ' تا ' + vm.$filters.toggleDate(item.endDate) : '');
                        }

                        item.fullTitle = this.getTitle(item)

                        this.listApplyDates.push(item);
                    }

                    this.finalListApplyDates = this.listApplyDates;

                    this.filterFinalList();
                }
                else {
                    this.$emit('update:value', { id: 0 });
                }
            },
            value(newVal) {
                if (newVal != null && newVal.id <= 0) {
                    this.selectApplyDate = null;
                }
                else
                    this.selectApplyDate = newVal;
            },
            selectApplyDate(newVal) {
                let valSet = newVal;
                if (newVal == undefined || newVal == null) {
                    valSet = { id: 0 };
                }

                this.$emit('update:value', valSet);
            },
            selectedMonth(newVal, oldVal) {
                if (newVal != oldVal)
                    this.filterFinalList();
            },
            selectedYear(newVal, oldVal) {
                if (newVal != oldVal)
                    this.filterFinalList();
            },
        },
        methods: {
            setValueToBox() {
                if (this.value && this.listData && this.listData.length > 0) {
                    let vm = this;
                    let item = this.listData.filter((v) => { return v.id == vm.value.id; })
                    if (item.length > 0) {
                        this.$emit('update:value', item[0]);
                    }
                }
                else {
                    if (this.countTrySetValue > 5)
                        return;
                    else {
                        let vm = this;
                        this.countTrySetValue++;
                        setTimeout(() => { vm.setValueToBox(); }, 1000);
                    }
                }
            },
            filterFinalList() {
                let list = this.listApplyDates;
                let vm = this;

                if (this.selectedYear > 0)
                    list = list.filter((v, i) => { return v.yearNo == vm.selectedYear; });

                if (this.selectedMonth > 0)
                    list = list.filter((v, i) => { return v.monthNo == vm.selectedMonth; });

                this.finalListApplyDates = list;
            }
        },
        created() { },
        mounted() {
            this.setValueToBox();
        },
        computed: {
            getTitle() {
                let vm = this;
                return ((item) => {
                    let title = '';
                    title = item.title;

                    if (item.isLock) {
                        title += ' - قفل شده';
                        if (item.finalConfirm == null)
                            title += ' - در جریان تاییدات';
                        else if (item.finalConfirm == true) {
                            title += ' - تایید نهایی شده';
                        }
                    }

                    if ((item.sectionTitles ?? '').trim().length > 0) {
                        title += '--' + item.sectionTitles
                    }

                    return title;
                });
            },
        }
    }

</script>